var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      [
        _c("p", { staticClass: "sign-up-subtitle" }, [
          _vm._v(_vm._s(_vm.$t("completed_profile")))
        ]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "formRef",
            attrs: { model: _vm.formData, rules: _vm.formRules },
            nativeOn: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "firstName" } },
              [
                _c("el-input", {
                  attrs: { placeholder: _vm.$t("first_name") },
                  model: {
                    value: _vm.formData.firstName,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "firstName", $$v)
                    },
                    expression: "formData.firstName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: { type: "text" }
            }),
            _vm._v(" "),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: { type: "password" }
            }),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { prop: "lastName" } },
              [
                _c("el-input", {
                  attrs: { placeholder: _vm.$t("last_name") },
                  model: {
                    value: _vm.formData.lastName,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "lastName", $$v)
                    },
                    expression: "formData.lastName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "form-btn", on: { click: _vm.confirm } },
              [_vm._v(_vm._s(_vm.$t("confirm")))]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa48519a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa48519a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Public/SignUp/Info.vue
// module id = null
// module chunks = 